import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import { RepairFactor, RepairFactorCollection } from './queryBuilder';

const useRepairFactor = () => {
  const getRepairFactorQuery = useCallback(
    (collection: RepairFactorCollection) => collection?.find(),
    [],
  );

  const { result: repairFactorListData } = useRxData<RepairFactor>(
    RxdbCollectionName.REPAIR_FACTOR,
    getRepairFactorQuery,
    { json: true },
  );

  return { repairFactorListData };
};

export default useRepairFactor;
